import { Component, ElementRef, HostListener, inject, signal, ViewChild } from '@angular/core';
import { SHARED_IMPORTS } from '../../shared/shared-imports';
import { Globals } from '../../shared/global';
import { idleService } from '../../shared/services/idle-service';
import { Router } from '@angular/router';
import { ApiCallingService } from '../../shared/services/api-calling-service';
import { MessageService } from 'primeng/api';
import { ApiRoutes } from '../../shared/api-routes';
import { environment } from '../../../environments/environment';
import { MsalService } from '@azure/msal-angular';
export const sharedBroadcast = new BroadcastChannel('');

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [SHARED_IMPORTS],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header {
  @ViewChild('customizerBox', { static: false }) customizerBox!: ElementRef;
  userId = signal('');
  userFullName = signal('');
  email = signal('');
  roleId = signal('');
  userRoleName = signal('');
  entityId = signal('');
  isDarkMode: boolean = false;
  openThemeCustomizer: boolean = false;
  isinterested: boolean = false;
  selectedThemeOption: any;
  headerLogo: string = '';
  userInitials = '';

  isLoggedIn = signal(false);

  themeOption = [
    { name: 'Light', key: 'light', icon: 'pi pi-sun' },
    { name: 'Dark', key: 'dark', icon: 'pi pi-moon' },
    { name: 'Auto', key: 'auto', icon: 'pi pi-desktop' },
  ];

  private prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
  private systemThemeListener = (e: MediaQueryListEvent) => this.applyTheme(e.matches);

  private router = inject(Router);

  constructor(
    private global: Globals,
    private idleService: idleService,
    private apiCallingService: ApiCallingService,
    private messageService: MessageService,
    private msalService: MsalService,
  ) { }

  ngOnInit(): void {
    const token = localStorage.getItem('Auth_token');
    const isUserLogged = localStorage.getItem('isUserLogged');
    this.isLoggedIn.set(!!(token && isUserLogged === 'true'));
    if (this.isLoggedIn()) {
      this.userId.set(`${this.global.getUserInfo()?.userId}`);
      const { firstName = '', lastName = '' } = this.global.getUserInfo() || {};
      this.userFullName.set(`${firstName} ${lastName}`.trim());
      this.email.set(`${this.global.getUserInfo()?.email}`);
      this.roleId.set(`${this.global.getUserInfo()?.roleId}`);
      this.userRoleName.set(`${this.global.getUserInfo()?.roleName}`);
      this.entityId.set(`${this.global.getUserInfo()?.entityId}`);

      const f = firstName?.charAt(0) ?? '';
      const l = lastName?.charAt(0) ?? '';
      this.userInitials = (f + l).toUpperCase();
    } else {
      this.getAccessPage(ApiRoutes.URLS.GET_ACCESS_PAGE_DATA, 'accesspage');
    }

    // Default to Dark
    this.selectedThemeOption = this.themeOption.find((t) => t.key === 'dark');
    this.applyTheme(true);
    const authUser = JSON.parse(localStorage.getItem('Auth-user') || '{}');
    const interestedDocuments = authUser?.user_info?.interestedDocuments ?? 0;
    this.isinterested = interestedDocuments === 1;
  }

  getAccessPage(url: string, type: 'accesspage'): void {
    let finalUrl = `${url}?publicKey=${environment.PublicKey}`;
    this.apiCallingService.callAuthPostAPI({}, 'GET', finalUrl).subscribe({
      next: (response: any) => {
        response = JSON.parse(response);
        if (response.responseCode === 200) {
          if (type === 'accesspage') {
            localStorage.setItem('accessPage', JSON.stringify(response.data));
          }
        }
      },
      error: (errorResponse: any) => {
        errorResponse = JSON.parse(errorResponse.error);
        const message = errorResponse.responseMessage
          ? errorResponse.responseMessage.toLowerCase()
          : '';
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail:
            errorResponse.responseMessage.charAt(0).toUpperCase() +
            errorResponse.responseMessage.slice(1).toLowerCase(),
        });
      },
    });
  }
  updateIntresetedDocument(url: string, type: 'interested', status: boolean): void {
    const finalUrl = `${url}?publicKey=${environment.PublicKey}`;

    const payload = {
      status: status
    };

    this.apiCallingService.callAuthPostAPI(payload, 'PUT', finalUrl).subscribe({
      next: (response: any) => {
        response = JSON.parse(response);
        if (response.responseCode === 200) {
          const authUser = localStorage.getItem('Auth-user');

          if (authUser) {
            const parsedAuthUser = JSON.parse(authUser);

            if (parsedAuthUser?.user_info) {
              parsedAuthUser.user_info.interestedDocuments = status;
            } else {
              parsedAuthUser.interestedDocuments = status;
            }
            window.location.reload();

            localStorage.setItem('Auth-user', JSON.stringify(parsedAuthUser));
          }

        }
      },
      error: (errorResponse: any) => {
        errorResponse = JSON.parse(errorResponse.error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail:
            errorResponse.responseMessage.charAt(0).toUpperCase() +
            errorResponse.responseMessage.slice(1).toLowerCase(),
        });
      },
    });
  }

  onInterestedToggleChange(event: any): void {
    console.log('onInterestedToggleChange');
    const status: any = event.checked ? 1 : 0;
    this.updateIntresetedDocument(ApiRoutes.URLS.INTERESTED_IN_DOCUMENT, 'interested', status);
  }

  goToDashboard(): void {
    this.router.navigate(['/landingpage']);
  }

  // Close theme customizer on outside click
  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const clickedInside = this.customizerBox?.nativeElement.contains(event.target);
    const clickedIcon =
      (event.target as HTMLElement).classList.contains('pi-cog') ||
      (event.target as HTMLElement).classList.contains('customizer-image');

    if (!clickedInside && !clickedIcon) {
      this.openThemeCustomizer = false;
    }
  }

  // Toggle theme customizer panel
  openThemeCustomize() {
    this.openThemeCustomizer = !this.openThemeCustomizer;
  }

  // Apply theme manually
  applyTheme(isDark: boolean) {
    this.isDarkMode = isDark;

    document.body.classList.toggle('theme-dark', isDark);
    this.headerLogo = isDark
      ? '/assets/images/moba-logo-yellow.png'
      : '/assets/images/moba-logo-black.png';
  }

  // Enable Auto mode (system preference)
  setAutoTheme() {
    this.applyTheme(this.prefersDark.matches);

    // Add system preference listener if not already added
    this.prefersDark.addEventListener('change', this.systemThemeListener);
  }

  // Handle theme selection
  onThemeChange(key: string, theme: any) {
    this.selectedThemeOption = theme;

    if (key === 'dark') {
      this.removeAutoThemeListener();
      this.applyTheme(true);
    } else if (key === 'light') {
      this.removeAutoThemeListener();
      this.applyTheme(false);
    } else if (key === 'auto') {
      this.setAutoTheme();
    }
  }

  // Optional: remove listener if user is not in auto mode anymore
  private removeAutoThemeListener() {
    this.prefersDark.removeEventListener('change', this.systemThemeListener);
  }

  // logOutUser(): void {
  //   const ssologin = localStorage.getItem('ssologin');
  //   this.idleService.logout();
  //   setTimeout(() => {
  //     this.idleService.broadcastMessage('logOut');
  //   }, 1000);

  //   if (ssologin === 'true') {
  //     localStorage.clear();
  //     localStorage.removeItem('ssologin');
  //     this.msalService.logoutRedirect({
  //       postLogoutRedirectUri: window.location.origin,
  //     });
  //   } else {
  //     this.router.navigate(['/login']);
  //   }
  // }

  logOutUser(): void {
    this.idleService.logout();
    // setTimeout(() => {
    //   this.idleService.broadcastMessage('logOut');
    // }, 1000);

    // DO NOT call msalService.logoutRedirect here.
    // Keeping the MSAL account cached allows auto-login to work on next page load.
    this.router.navigate(['/login']);
  }

  goToLogin(): void {
    this.router.navigate(['/login']);
  }
}
